var ko = require('knockout');
var enquire = require('enquire.js');

var smallOnlyMQ = 'screen and (max-width: 40em)',
  mediumOnlyMQ = 'screen and (min-width: 40.0625em) and (max-width: 63.9375em)',
  largeUpMQ = 'screen and (min-width: 64em)',
  small = {
    match: function() {
      equalHeightTiles(true);
      ko.postbox.publish('resize', 'small');
    },
    unmatch: function() {}
  },
  medium = {
    match: function() {
      equalHeightTiles(true);
      ko.postbox.publish('resize', 'medium');
    },
    unmatch: function() {}
  },
  large = {
    match: function() {
      equalHeightTiles(true);
      ko.postbox.publish('resize', 'large');
    },
    unmatch: function() {}
  };

enquire.register(smallOnlyMQ, small);
enquire.register(mediumOnlyMQ, medium);
enquire.register(largeUpMQ, large);

function equalHeightTiles() {
  var doEqualHeightTiles = function() {
    var $tile = $('.block-grid-tile > li'),
      $textArea = $tile.find('.media-tile-text-wrapper'),
      tallest = 0;

    $textArea.css('height', 'auto');

    $.each($tile, function() {
      var $text = $(this).find('.media-tile-text-wrapper'),
        textHeight = $text.outerHeight();

      if (textHeight > tallest) {
        tallest = textHeight;
      }
    });
    $textArea.outerHeight(tallest);
  };

  if ($('.block-grid-tile').length) {
    doEqualHeightTiles();

    $(window).on('afterresize', function() {
      doEqualHeightTiles();
    });
  }
}
